"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { getTimeAgoShort } from "@/helpers/Helpers";
interface BrainLeftSidebarWaveDropTimeProps {
  readonly time: number;
}
const BrainLeftSidebarWaveDropTime: React.FC<BrainLeftSidebarWaveDropTimeProps> = t0 => {
  const $ = _c(6);
  const {
    time
  } = t0;
  const [, setTick] = useState(0);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const intervalId = setInterval(() => {
        setTick(_temp);
      }, 60000);
      return () => {
        clearInterval(intervalId);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== time) {
    t3 = getTimeAgoShort(time);
    $[2] = time;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="tw-text-iron-300">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default BrainLeftSidebarWaveDropTime;
function _temp(prev) {
  return prev + 1;
}